import { Skeleton } from 'antd';
import { PageLayout } from '../../components/layout/PageLayout';
import { Newspaper } from 'lucide-react';

export const ArticleSkeleton = () => {
  return (
    <PageLayout
      breadcrumbProps={{
        items: [
          { label: 'Actualités', path: '/actualites', icon: <Newspaper className="w-4 h-4" /> },
          { label: 'Chargement...', path: '#' }
        ]
      }}
      className="py-8"
    >
      <div className="bg-white rounded-2xl shadow-sm overflow-hidden max-w-7xl mx-auto">
        {/* En-tête de l'article */}
        <div className="px-4 sm:px-6 lg:px-8 pt-8 pb-12 bg-gradient-to-br from-primary/5 to-primary/10">
          <Skeleton.Input active size="large" className="!w-[80%] !h-[50px] !mb-6" />

          <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
            <Skeleton.Input active size="small" className="!w-[120px]" />
            <Skeleton.Input active size="small" className="!w-[100px]" />
            <div className="flex items-center gap-2 flex-wrap">
              <Skeleton.Input active size="small" className="!w-[80px]" />
              <Skeleton.Input active size="small" className="!w-[80px]" />
            </div>
          </div>
        </div>

        {/* Image principale */}
        <div className="relative">
          <Skeleton.Image active className="!w-full !h-[300px]" />
        </div>

        {/* Contenu de l'article */}
        <div className="px-4 sm:px-6 lg:px-8 py-12">
          <article>
            {/* Titre de section */}
            <Skeleton.Input active size="large" className="!w-[70%] !h-[40px] !mb-8" />
            
            {/* Paragraphes */}
            <Skeleton active paragraph={{ rows: 3 }} className="mb-8" />
            
            {/* Image */}
            <div className="my-8">
              <Skeleton.Image active className="!w-full !h-[250px] !rounded-xl !mx-auto !max-w-2xl" />
            </div>
            
            {/* Sous-titre */}
            <Skeleton.Input active size="large" className="!w-[50%] !h-[30px] !my-6" />
            
            {/* Plus de paragraphes */}
            <Skeleton active paragraph={{ rows: 4 }} className="mb-8" />
            
            {/* Citation */}
            <div className="border-l-4 border-primary bg-primary/5 px-6 py-4 rounded-r-lg my-8">
              <Skeleton active paragraph={{ rows: 2 }} />
            </div>
            
            {/* Encore plus de contenu */}
            <Skeleton active paragraph={{ rows: 3 }} className="mb-8" />

            {/* Navigation retour */}
            <div className="border-t border-neutral-200 pt-8 mt-8">
              <div className="inline-block w-48 h-10 bg-primary/5 rounded-lg"></div>
            </div>
          </article>
        </div>
      </div>
    </PageLayout>
  );
}; 